"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vacuumImpedanceDependencies = void 0;

var _dependenciesBigNumberClassGenerated = require("./dependenciesBigNumberClass.generated.js");

var _dependenciesUnitClassGenerated = require("./dependenciesUnitClass.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var vacuumImpedanceDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated.UnitDependencies,
  createVacuumImpedance: _factoriesAny.createVacuumImpedance
};
exports.vacuumImpedanceDependencies = vacuumImpedanceDependencies;